import { Component } from '@angular/core';

import { FooterComponent } from '../components/footer/footer.component';

@Component({
  selector: 'umkt-auth-layout',
  standalone: true,
  imports: [FooterComponent],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss'
})
export class AuthLayoutComponent {

}
